import Vue from 'vue'
import VueRouter from 'vue-router'
import {
  firebaseAuth
} from "../main";

Vue.use(VueRouter)

const routes = [{
    path: '/',
    redirect: '/login'
  },
  {
    // =============================================================================
    // MAIN LAYOUT ROUTES
    // =============================================================================
    path: '',
    component: () => import('../layouts/Main.vue'),
    children: [{
        path: '/dashboard',
        name: 'Dashboard',
        component: () => import( /* webpackChunkName: "about" */ '../views/Dashboard.vue'),
        meta: {
          requiresAuth: true
        }
      },
      {
        path: '/job/:id',
        name: 'job-view',
        component: () => import( /* webpackChunkName: "about" */ '../views/Detail.vue'),
        meta: {
          requiresAuth: true
        }
      },
      {
        path: '/enquiry/:id',
        name: 'enquiry-view',
        component: () => import( /* webpackChunkName: "about" */ '../views/EnquiryDetail.vue'),
        meta: {
          requiresAuth: true
        }
      },
      {
        path: '/job-archive/:id',
        name: 'job-archive-view',
        component: () => import( /* webpackChunkName: "about" */ '../views/DetailArchive.vue'),
        meta: {
          requiresAuth: true
        }
      },
      {
        path: '/create-job',
        name: 'Create New Job',
        component: () => import( /* webpackChunkName: "about" */ '../views/CreateJob.vue'),
        meta: {
          requiresAuth: true
        }
      },
      {
        path: '/completed',
        name: 'Recent Completed Jobs',
        component: () => import( /* webpackChunkName: "about" */ '../views/Completed.vue'),
        meta: {
          requiresAuth: true
        }
      },
      {
        path: '/bulk-edit',
        name: 'bulk-edit',
        component: () => import( /* webpackChunkName: "about" */ '../views/BulkEdit.vue'),
        meta: {
          requiresAuth: true
        }
      },
      {
        path: '/archive',
        name: 'Archive',
        component: () => import( /* webpackChunkName: "about" */ '../views/ArchiveNew.vue'),
        meta: {
          requiresAuth: true
        }
      },
      {
        path: '/enquires',
        name: 'Enquiries',
        component: () => import( /* webpackChunkName: "about" */ '../views/Enquiry.vue'),
        meta: {
          requiresAuth: true
        }
      },
      {
        path: '/users',
        name: 'Users',
        component: () => import( /* webpackChunkName: "about" */ '../views/Users.vue'),
        meta: {
          requiresAuth: true
        }
      },
      {
        path: '/profile',
        name: 'profile',
        component: () => import( /* webpackChunkName: "about" */ '../views/Profile.vue'),
        meta: {
          requiresAuth: true
        }
      },
      {
        path: '/users/:id',
        name: 'user-view',
        component: () => import( /* webpackChunkName: "about" */ '../views/NewUser.vue'),
        meta: {
          requiresAuth: true
        }
      },
      {
        path: '/new-user',
        name: 'NewUser',
        component: () => import( /* webpackChunkName: "about" */ '../views/NewUser.vue'),
        meta: {
          requiresAuth: true
        }
      },
      {
        path: '/inward-goods',
        name: 'InwardGoods',
        component: () => import( /* webpackChunkName: "about" */ '../views/InwardGoodsList.vue'),
        meta: {
          requiresAuth: true
        }
      },
      {
        path: '/organisations',
        name: 'Organisations',
        component: () => import( /* webpackChunkName: "about" */ '../views/Organisations.vue'),
        meta: {
          requiresAuth: true
        }
      },
      {
        path: '/organisations/:orgId/timesheet',
        name: 'timesheet',
        component: () => import( /* webpackChunkName: "about" */ '../views/TimeSheet.vue'),
        meta: {
          requiresAuth: true
        }
      },
      {
        path: '/organisations/:orgId/users',
        name: 'org-users',
        component: () => import( /* webpackChunkName: "about" */ '../views/Users.vue'),
        meta: {
          requiresAuth: true
        }
      },
      {
        path: '/organisations/:orgId/new-user',
        name: 'org-new-user',
        component: () => import( /* webpackChunkName: "about" */ '../views/NewUser.vue'),
        meta: {
          requiresAuth: true
        }
      },
      {
        path: '/full-search',
        name: 'Testing',
        component: () => import( /* webpackChunkName: "about" */ '../views/FullSearch.vue'),
        meta: {
          requiresAuth: true
        }
      },
      {
        path: '/about',
        name: 'About',
        // route level code-splitting
        // this generates a separate chunk (about.[hash].js) for this route
        // which is lazy-loaded when the route is visited.
        component: () => import( /* webpackChunkName: "about" */ '../views/About.vue')
      },
      {
        path: '/help',
        name: 'Help',
        component: () => import( /* webpackChunkName: "about" */ '../views/Help.vue')
      },
    ]
  },
  {
    path: '',
    component: () => import('../layouts/FullView.vue'),
    children: [{
      path: '/login',
      name: 'Login',
      component: () => import( /* webpackChunkName: "about" */ '../views/Login.vue'),
    }, ]
  },
  {
    path: '',
    component: () => import('../layouts/KioskView.vue'),
    children: [{
      path: '/in',
      name: 'InwardsGoodsForm',
      component: () => import( /* webpackChunkName: "about" */ '../views/InwardGoodsForm.vue'),
      meta: {
        requiresAuth: true
      }
    }, ]
  },
  {
    path: '',
    component: () => import('../layouts/FullView.vue'),
    children: [{
      path: '/forgot',
      name: 'Forgot',
      component: () => import( /* webpackChunkName: "about" */ '../views/Forgot.vue'),
    }, ]
  }
]


const router = new VueRouter({
  routes
})

//Think this pushes logined in user to Dashboard
router.beforeEach((to, from, next) => {
  let currentUser = firebaseAuth().currentUser;
  let requiresAuth = to.matched.some(record => record.meta.requiresAuth)

  if (requiresAuth && !currentUser) next({ name: 'Login', query: {from: to.path}});
  else if (to.name === 'Login' && !requiresAuth && currentUser && currentUser.role === 5) next('in') //is inward goods receiver
  else if (to.name === 'Login' && !requiresAuth && currentUser) next('dashboard')
  else next()
})

export default router